import { NextURL } from 'next/dist/server/web/next-url'
import { NextRequest } from 'next/server'
import qs from 'query-string'

export function cloneNextUrlForPathname(
  pathname: string,
  request: NextRequest,
  options?: { search?: string; defaultSearch?: Record<string, string> },
): NextURL {
  const parts = pathname.split('?')
  const justPath = parts[0]
  const search = parts[1] ? `?${parts[1]}` : null

  const clonedUrl = request.nextUrl.clone()
  clonedUrl.pathname = `${justPath}`

  if (search) {
    clonedUrl.search = search
  }
  if (options?.search) {
    const parsedSearch = qs.parse(clonedUrl.search)
    const parsedOptions = qs.parse(options.search)
    const searchAddedFromOptions = {
      ...parsedSearch,
      ...parsedOptions,
    }
    clonedUrl.search = `?${qs.stringify(searchAddedFromOptions)}`
  }
  if (options?.defaultSearch) {
    const parsedSearch = qs.parse(clonedUrl.search)
    const searchWithDefaults = {
      ...options.defaultSearch,
      ...parsedSearch,
    }
    clonedUrl.search = `?${qs.stringify(searchWithDefaults)}`
  }

  return clonedUrl
}
